<template>
  <div class="media">
    <Empty v-if="!page.list.length" />
    <van-pullRefresh v-else v-model="page.refreshing" @refresh="onRefresh()">
      <van-List
        v-model="page.loading"
        :finished="page.finished"
        @load="onLoad()"
      >
        <div class="list">
          <div class="mediaItem" v-for="(item,index) in page.list" :key="index" @click="$router.push({name:'StudyMediaDetail',query:{id:item.id,title:item.name}})">
            <div class="card">
              <img class="img" :src="item.image || require('@/assets/images/img_default_02.png')" />
              <div class="title text-ellipsis">{{item.name}}</div>
            </div>
          </div>
        </div>
        <template #finished>
          <van-divider style="width:50%;margin:20px auto;">滑到底啦</van-divider>
        </template>
      </van-List>
    </van-pullRefresh>
  </div>
</template>

<script>
export default {
  name: 'Media',
  data () {
    return {
      page: {
        pageNo: 1,
        pageSize: 20,
        list: [],
        loading: false,
        finished: false,
        refreshing: false
      }
    };
  },
  created () {
    this.onLoad();
  },
  watch: {
    active () {
      this.onRefresh();
    }
  },
  methods: {
    onLoad () {
      const { page } = this;
      const params = {
        pageNo: page.pageNo,
        pageSize: page.pageSize
      };
      if (page.refreshing) {
        page.list = [];
        page.refreshing = false;
      }
      this.$http.get('courseTeach/media/list', { params, showLoading: true }).then((res) => {
        const data = res.data.page;
        if (!data.isHasNext) {page.finished = true;}
        page.pageNo = data.nextPage;
        page.list.push(...data.result);
        page.loading = false;
        this.page = page;
      });
    },
    onRefresh () {
      // 清空列表数据 重新加载数据
      this.page = {
        pageNo: 1,
        pageSize: 20,
        list: [],
        loading: true,
        finished: false,
        refreshing: true
      };
      this.onLoad();
    }
  }
};
</script>

<style lang="less" scoped>
.media {
  background-color: #f8f8f8;
  height: calc(100vh - 94px);
  .list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .mediaItem {
      margin-top: 20px;
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      .card {
        width: 336px;
        background-color: #fff;
        border-radius: 8px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        .img {
          width: 336px;
          height: 224px;
        }
        .title {
          padding: 16px 20px;
          font-size: 26px;
          color: #333444;
        }
      }
    }
  }
  #video {
    width: 100vw;
    height: 400px;
  }
}
</style>